import { render, staticRenderFns } from "./traffic-boost-dialog.vue?vue&type=template&id=892ab1c2&scoped=true"
import script from "./traffic-boost-dialog.vue?vue&type=script&lang=js"
export * from "./traffic-boost-dialog.vue?vue&type=script&lang=js"
import style0 from "./traffic-boost-dialog.vue?vue&type=style&index=0&id=892ab1c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ab1c2",
  null
  
)

export default component.exports